import React from 'react';

import {
  BlackActionButton,
  PageStatusBanner,
  SummaryLink,
} from '@internal/components/project-view/project-view.styled';

import { ApplicationLinkAction, BannerModel } from './application-progress';
import { BannerActions } from './application-view.styled';

interface ApplicationStateBannerProps {
  banner: BannerModel;
  onSummary: () => void;
  onAction: (action: ApplicationLinkAction) => void;
  fallbackAction?: { label: string; onClick: () => void };
  showSummary?: boolean;
}

const ApplicationStateBanner: React.FC<ApplicationStateBannerProps> = ({
  banner,
  onSummary,
  onAction,
  fallbackAction,
  showSummary = true,
}) => (
  <PageStatusBanner
    severity="info"
    title={banner.title}
    action={
      <BannerActions>
        {showSummary && (
          <SummaryLink
            type="button"
            onClick={onSummary}
            data-testid="application-summary"
          >
            View summary
          </SummaryLink>
        )}
        {banner.next ? (
          <BlackActionButton
            type="button"
            onClick={() => banner.next && onAction(banner.next)}
            data-testid="application-next-action"
          >
            {banner.next.label}
          </BlackActionButton>
        ) : (
          banner.allowFallback &&
          fallbackAction && (
            <BlackActionButton
              type="button"
              onClick={fallbackAction.onClick}
              data-testid="application-next-action"
            >
              {fallbackAction.label}
            </BlackActionButton>
          )
        )}
      </BannerActions>
    }
  >
    {banner.detail}
  </PageStatusBanner>
);

export default ApplicationStateBanner;
